<div class="contractor-user-container">
  <div class="mt-1 ms-2 contractor-user-title">
    <h2 class="pt-1 my-3 ms-3">Asociar prestador a vendedor</h2>
  </div>
  <div class="body">
    <form [formGroup]="contractorUserForm">
      <div class="w-100 dialog-content">
        @if (!previusUser) {
          <span
            >¿A qué vendedor deseas asociar el prestador seleccionado?</span
            >
          }
          @if (previusUser) {
            <span
              ><img
              src="../../../../assets/icons/common/warning.svg"
              alt="warning"
              />
              Ya hay un vendedor asociado a este prestador. Recuerde que si
              selecciona uno nuevo, el anterior se eliminará de la asociación.</span
              >
            }
          </div>
          <div class="row mb-2 ms-1">
            <span class="mb-1 ps-0">Prestador</span>
            <input
              class="ms-3 contractor-input"
              type="text"
              formControlName="contractorName"
              placeholder="Prestador"
              required
              [disabled]="true"
              />
            </div>
            <div class="row pb-5 ms-1">
              <span class="mt-3 mb-1 ps-0">Vendedor</span>
              <mat-form-field appearance="outline" class="ms-1 float-left">
                <input
                  type="text"
                  placeholder="Vendedor"
                  matInput
                  formControlName="sellerName"
                  [matAutocomplete]="auto"
                  />
                  <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
                    @for (user of filteredOptions | async; track user) {
                      <mat-option
                        (click)="selectUser(user)"
                        [value]="user.name"
                        (keydown)="selectUser(user)"
                        >
                        {{ user.name }}
                      </mat-option>
                    }
                  </mat-autocomplete>
                </mat-form-field>
              </div>
            </form>
          </div>
          <div class="row buttons-footer justify-content-end buttons-contractor-user">
            <button type="button" class="ind-button-lite" (click)="closeClick()">
              <span class="text-buttons">Cancelar</span>
              </button>

              <button
                type="button"
                class="ind-button"
                [disabled]="contractorUserForm.invalid"
                (click)="save()"
                >
                <span class="text-buttons">Guardar</span>
              </button>
            </div>
          </div>
